
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire3976"];
var parcelRegister = parcelRequire.register;
parcelRegister("5w9ds", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $526d5f99ae71f983$export$2e2bcd8739ae039; });
/* eslint-disable tailwindcss/classnames-order */ 
var $e1vzu = parcelRequire("e1vzu");

var $3QbnI = parcelRequire("3QbnI");

var $3usLb = parcelRequire("3usLb");

var $ctHcP = parcelRequire("ctHcP");
const $526d5f99ae71f983$var$BookHeader = ()=>{
    const { setIsOpen: setIsOpen } = (0, $3QbnI.useContext)((0, $ctHcP.BookNavModalContext));
    const chapterToNumber = (0, $3QbnI.useCallback)((value)=>value ? value.replace(/#?ch-/, "") : "1", []);
    const [chapterNumber, setChapterNumber] = (0, $3QbnI.useState)(chapterToNumber(window.location.hash));
    // @TODO: consider switching link updates with `pushState`
    (0, $3QbnI.useEffect)(()=>{
        const hashChange = ()=>{
            const hash = window.location.hash;
            const newChapter = chapterToNumber(hash);
            // reset scrollRef so observer doesn't think this is scrolling up
            scrollRef.current = 0;
            setChapterNumber(newChapter);
        };
        window.addEventListener("hashchange", hashChange, false);
        return ()=>{
            window.removeEventListener("hashchange", hashChange);
        };
    }, [
        chapterToNumber
    ]);
    const scrollRef = (0, $3QbnI.useRef)(0);
    const bookTitle = (0, $3usLb.data).title;
    // @see https://reacthustle.com/blog/how-to-track-scroll-direction-inside-intersection-observer-in-react
    (0, $3QbnI.useEffect)(()=>{
        const chapters = Array.from(document.querySelectorAll(".Chapter-number, .Psalm-Chapter-Title"));
        const ids = chapters.map((e)=>e.id);
        const observer = new IntersectionObserver((entries)=>{
            entries.forEach((entry)=>{
                const id = entry.target.getAttribute("id") ?? "";
                if (entry.isIntersecting) {
                    setChapterNumber(chapterToNumber(id));
                    scrollRef.current = window.scrollY;
                    return;
                }
                const diff = scrollRef.current - window.scrollY;
                const isScrollingUp = diff > 0;
                const currentIndex = ids.indexOf(id);
                const prevEntry = ids[currentIndex - 1];
                if (isScrollingUp) {
                    const id = prevEntry;
                    setChapterNumber(chapterToNumber(id));
                }
            });
        }, {
            rootMargin: "0% 0% -77% 0%",
            threshold: 0.2
        });
        chapters.forEach((el)=>{
            observer.observe(el);
        });
        return ()=>{
            observer.disconnect();
        };
    }, []);
    return /*#__PURE__*/ (0, $e1vzu.jsx)("button", {
        className: "whitespace-nowrap rounded-md px-2 py-1",
        onClick: ()=>{
            setIsOpen(true);
        },
        children: /*#__PURE__*/ (0, $e1vzu.jsxs)("div", {
            className: "border-b-2 border-dotted border-white px-2 py-0 text-2xl text-white",
            children: [
                bookTitle,
                " ",
                chapterNumber
            ]
        })
    });
};
var $526d5f99ae71f983$export$2e2bcd8739ae039 = $526d5f99ae71f983$var$BookHeader;

});


//# sourceMappingURL=BookHeader.dc1db030.js.map
